import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/global/footer.tsx")